import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { updateGridRecord } from '@/services/grid'
import { showNotification } from '@/services/calculate'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Admin/MasterData/GridRenderer/actionRendere'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'

export default {
  props: ['estimateGroups'],
  components: {
    'ag-grid-vue': AgGridVue,
  },
  data: function() {
    return {
      loading: true,
      list: [],
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      width: '100%',
      height: '45em',
      visible: false,
      closable: true,
      postSort: null,
      selectedRowKeys: [],
      selectedRows: [],
      modalWidth: '110rem',
      padding: '0px',
    }
  },
  beforeMount() {
    this.visible = true
    window.addEventListener('resize', this.detectViewPortListener)
    this.postSort = rowNodes => {
      const sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        sortedData.push(rowNodes[i].data)
      }
      this.list = [...sortedData]
    }
    this.loadingConfig()
  },
  mounted() {
    this.$root.$off('deleteEstimateGroup')
    this.$root.$on('deleteEstimateGroup', this.deleteBank)
    this.$root.$off('updateEstimateGroup')
    this.$root.$on('updateEstimateGroup', this.onUpdate)
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        rowDragManaged: true,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
        },
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        toolTipRenderer: ToolTipRenderer,
        customFilter: CustomFilter,
        textEditor: TextEditor,
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          cellStyle: { textAlign: 'right' },
        },
        {
          field: '0',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Estimate Group',
          field: 'estimateGroupName',
          width: 500,
          filter: 'customFilter',
          headerTooltip: 'Estimate Group',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'estimateGroups',
            searchType: 'string',
          },
          editable: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 80,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'estimateGroups',
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    onClose() {
      this.visible = false
      this.$emit('onClose', false)
    },

    onLoad(params) {
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      params.api.setRowData(this.estimateGroups)
      this.loading = false
    },

    onRowSelected() {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged() {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    deleteBank(record) {
      var that = this
      this.$confirm({
        title: `Are you sure you want to delete '${record.estimateGroupName}' ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this estimate
              group.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
      })
    },

    deleteMultipleBanks() {
      var that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected estimate groups ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this estimate
              group.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
      })
    },

    confirmDelete(record) {
      this.loading = true
      const request = []
      const url = projectAPIs.project.asset.estimate.delete(
        this.$route.params.id,
        record ? record.assetId : this.list[0].assetId,
      )
      if (record) {
        request.push(record.id)
      } else {
        this.selectedRows.forEach(element => {
          request.push(element.id)
        })
      }
      instance
        .delete(url, { data: request })
        .then(response => {
          request.forEach(element => {
            const index = this.list.findIndex(i => i.id === element.id)
            this.list.splice(index, 1)
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.gridOptions.api.deselectAll()
          this.$emit('onClose', null, request, 'delete')
          this.loading = false
          this.selectedRowKeys = []
          this.selectedRows = []
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onUpdate(value, record, key, index) {
      const currentValue = value === 0 ? value.toString() : !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (
        currentValue !== null &&
        previousValue.toString() !== currentValue.toString()
      ) {
        const url = projectAPIs.project.asset.estimate.update(
          this.$route.params.id,
          record.assetId,
        )

        const request = [
          {
            id: record.id,
            estimateGroupName: value,
          },
        ]
        const group = { ...record }

        if (value) {
          this.loading = true
          instance
            .patch(url, request)
            .then(response => {
              const newData = [...this.list]
              newData[index] = record
              this.list = [...newData]
              this.gridOptions.api.redrawRows()
              const itemsToUpdate = updateGridRecord(
                this.gridOptions,
                record,
                newData[index],
              )
              this.gridOptions.api.applyTransaction({
                update: itemsToUpdate,
              })
              this.gridOptions.api.redrawRows()
              this.loading = false
              this.$emit('onClose', record, null, 'update')
            })
            .catch(err => {
              this.loading = false
              this.resetRowData(index, group)
              this.$emit('onClose', group, null, 'error')
              errorService(err)
            })
        } else {
          showNotification(
            'warning',
            'Estimate Group',
            'Please enter estimate group name!',
          )
          this.resetRowData(index, group)
        }
      }
    },

    resetRowData(index, record) {
      const newData = [...this.list]
      newData[index] = record
      this.list = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        record,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.$emit('resetData', record)
    },

    sortChanged(node) {
      const isSortApplied = this.gridOptions.columnApi
        .getColumnState()
        .filter(
          i => i.colId !== 'action' && i.colId !== 'display' && i.colId !== '0',
        )
        .some(element => element.sort)
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide: isSortApplied,
          },
        ],
      })
    },

    onRowDragEnd(e) {
      this.loading = true
      const request = []
      this.list.forEach((i, index) => {
        request.push({
          id: i.id,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    reorder(request) {
      const url = projectAPIs.project.asset.estimate.update(
        this.$route.params.id,
        this.list[0].assetId,
      )
      instance
        .patch(url, request)
        .then(response => {
          this.loading = false
          this.selectedRowKeys = []
          this.selectedRows = []
          this.gridOptions.api.deselectAll()
          this.$emit('onClose', null, null, 'sequence')
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.modalWidth = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.modalWidth = '100%'
        this.padding = '10px !important'
      } else {
        this.modalWidth = '110rem'
        this.padding = '0px !important'
      }
    },
  },
}
